/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardian_Add_ChildInputs */

const fr_guardian_add_child = /** @type {(inputs: Guardian_Add_ChildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter un enfant`)
};

/**

* @param {Guardian_Add_ChildInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const guardian_add_child = /** @type {((inputs?: Guardian_Add_ChildInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardian_Add_ChildInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_guardian_add_child(inputs)
});